<template>
  <div>
    <BaseFrame>
      <div slot="content">
        <lk-card class="mb16">
          <template v-for="(item, index) in codeArr">
            <lk-button
              class="mr8"
              :key="item.code"
              type="primary"
              v-if="permissionFunc(item.permissionStr)"
              @click="handleQueryModal(item, index)">{{`${item.title}(${item.code})`}}
            </lk-button>

          </template>
        </lk-card>
        <!-- <lk-card></lk-card> -->

      <lk-modal
          v-model="queryModal.visiable"
          :title="queryModal.title"
          width="800"
          @on-ok="handleOk(queryModal.index)">
        <div v-if="curCode===919">
            <div class="queryList">
              <div class="queryItem">
                <label>结算日期:</label>
                <timeStampDatePicker type='daterange' v-model="query.duration"></timeStampDatePicker>
              </div>
              <div class="queryItem">
                <label>就医类别:</label>
                <lk-input v-model="query.medicineType"></lk-input>
              </div>
              <div class="queryItem">
                <label>审核标志:</label>
                <lk-select v-model="query.approveStatus">
                  <lk-option :value='1'>已审核</lk-option>
                  <lk-option :value='0'>未审核</lk-option>
                </lk-select>
              </div>
              <div class="queryItem">
                <label>参保地:</label>
                <lk-input v-model="query.insurancePlace"></lk-input>
              </div>
              <div class="queryItem">
                <label>结算方式:</label>
                <lk-input v-model="query.settlementMethod"></lk-input>
              </div>
            </div>
          </div>
          <div v-else-if="curCode===920">
            <div class="queryList">
              <div class="queryItem">
                <label>结算日期:</label>
                <timeStampDatePicker v-model="query.queryDate"></timeStampDatePicker>
              </div>

              <div class="queryItem">
                <label>参保地:</label>
                <lk-input v-model="query.insurancePlace"></lk-input>
              </div>


            </div>
          </div>
          <div v-else-if="curCode===921">
            <div class="queryList">
              <div class="queryItem">
                <label>结算日期:</label>
                <timeStampDatePicker v-model="query.queryDate"></timeStampDatePicker>
              </div>

              <div class="queryItem">
                <label>参保地:</label>
                <lk-input v-model="query.insurancePlace"></lk-input>
              </div>
            </div>
          </div>
          <div v-else-if="curCode===918">
            <div class="queryList">
              <div class="queryItem">
                <label>就医流水号:</label>
                <lk-input v-model="query.medicineSerialNo"></lk-input>
              </div>
              <div class="queryItem">
                <label>就医类别:</label>
                <lk-input v-model="query.medicineType"></lk-input>
              </div>

              <div class="queryItem">
                <label>参保地:</label>
                <lk-input v-model="query.insurancePlace"></lk-input>
              </div>
            </div>
          </div>
        <div v-else-if="curCode === 702 || curCode === 704">
          <div class="queryContainer">
            <div class="queryItem">
              <label>入院起止日期:</label>
              <timeStampDatePicker type="daterange" placeholder="请选择" v-model="query.hospitalizedRange"></timeStampDatePicker>
            </div>
            <div class="queryItem">
              <label>结算起止日期:</label>
              <timeStampDatePicker type="daterange" placeholder="请选择" v-model="query.settlementRange"></timeStampDatePicker>
            </div>
            <div class="queryItem">
              <label>个人编号:</label>
              <lk-select class="item" v-model.trim="query.userCode" clearable>
                <lk-option v-for="item in userList" :value="item.userCode" :key="item.userCode">
                  {{ item.userName }}
                </lk-option>
              </lk-select>
            </div>
            <div class="queryItem">
              <label>参保人所属经办机构代码:</label>
              <lk-input class="item" clearable :maxlength="100" placeholder="请输入" v-model="query.areaCode"></lk-input>
            </div>
          </div>
        </div>
        <div v-else-if="curCode === 705 ">
          <div class="queryContainer">
            <div class="queryItem">
              <label>结算年月:</label>
              <timeStampDatePicker placeholder="请输入" class="item" clearable type="month" v-model.trim="query.queryDate"></timeStampDatePicker>
            </div>
            <div class="queryItem">
              <label>参保地:</label>
              <lk-input :maxlength="100" placeholder="请输入" class="item" clearable v-model.trim="query.insurancePlace"></lk-input>
            </div>
          </div>
        </div>
        <!-- <div v-else-if="curCode===920"></div> -->
      </lk-modal>
      <lk-card v-if="showUserInfo" title="个人信息">
        <div>
<lk-form>
  <lk-row v-for="(item,i) in userInfoList" :key="i">
  <lk-form-item :label='item.label+":"'>{{userInfo[item.key]}}</lk-form-item>
  </lk-row>
</lk-form>
        </div>
      </lk-card>
      </div>

    </BaseFrame>
  </div>
</template>
<script>
import BaseFrame from '../../../components/frame/BaseFrame.vue';
import utils from '../../../libs/utils';
import insurance from '../../../services/insurance';
import mapState from '../../../mixins/mapState'; // 鉴权
import permission from '../../../mixins/permission';

export default {
  name: 'StatementCheck',
  mixins: [
    mapState,
    permission,

  ],
  components: {
    BaseFrame,
  },
  data() {
    return {
      query: {

      },
      queryModal: {
        visiable: false,
        title: '',
        index: 0,
      },
      curCode: null,
      userList: [],
      codeArr: [
        {
          code: 918,
          title: '获取结算单',
          permissionStr: 'reportStatement', // 权限字符串
          callback: this.statement, // 确认按钮执行的方法
          params: [], // 方法的参数
        },
        {
          code: 919,
          title: '获取月度申报对账表',
          permissionStr: 'reportDeclarationReconciliation',
          callback: this.declarationReconciliation,
          params: [],
        },
        {
          code: 920,
          title: '获取月度结算汇总表',
          permissionStr: 'reportStatementMonthCount',
          callback: this.statementMonthCount,
          params: [],
        },
        {
          code: 921,
          title: '获取医保月度结算单',
          permissionStr: 'reportInsuranceMonthStatement',
          callback: this.insuranceMonthStatement,
          params: [],
        },
        {
          code: 702,
          title: '费用明细下载',
          permissionStr: 'expensesDownload',
          callback: this.costInfoDownload,
          params: [true],
        },
        {
          code: 704,
          title: '结算信息下载',
          permissionStr: 'statementCheckDownload',
          callback: this.costInfoDownload,
          params: [],
        },
        {
          code: 705,
          title: '月度结算下载',
          permissionStr: 'monthStatementDownload',
          callback: this.monthSettlementExport,
          params: [],
        },
        {
          code: '001',
          title: '个人账户查询',
          permissionStr: 'userCheckInsurance',
          callback: this.userCheckInsurance,
          params: [],
        },
      ],
      showUserInfo: false,
      userInfo: {},
      userInfoList: [
        {
          label: '个人编号',
          key: 'aac001',
        },
        {
          label: '身份证号',
          key: 'aac002',
        },
        {
          label: '姓名',
          key: 'aac003',
        },
        {
          label: '性别',
          key: 'aac004',
        },
        {
          label: '出生日期',
          key: 'aac005',
        },
        {
          label: '单位名称',
          key: 'aab004',
        },
        {
          label: '人员状态',
          key: 'aac008',
        },
        {
          label: '医疗照顾人员标志',
          key: 'akc401',
        },
        {
          label: '参加公务员统筹',
          key: 'bkc281',
        },
        {
          label: '医疗人员类别',
          key: 'akc021',
        },
        {
          label: '年度统筹支付',
          key: 'bkc258',
        },
        {
          label: '年度住院次数',
          key: 'bkc255',
        },
        {
          label: '公务员类别',
          key: 'bac515',
        },
        {
          label: '慢性病年限额',
          key: 'bkc249',
        },
        {
          label: '账户余额',
          key: 'bkc276',
        },
        {
          label: '年度慢性病余额',
          key: 'bkc058',
        },
        {
          label: '备案病种',
          key: 'diseaseStr',
        },
      ],
    };
  },
  methods: {

    handleQueryModal(item, index) {
      if (item.code === '001') {
        this.showUserInfo = true;
        this.userCheckInsurance();
        return;
      }
      this.showUserInfo = false;


      this.query = {};
      this.curCode = Number.parseInt(item.code, 10);

      this.queryModal.visiable = true;
      this.queryModal.title = item.title;
      this.queryModal.index = index;
    },
    handleReset() {

    },
    handleOk(index) {
      const { params, callback } = this.codeArr[index];
      callback.apply(params);
    },
    insuranceMonthStatement() {
      const params = Object.assign({}, this.query);
      insurance.insuranceMonthStatement(params).then((res) => {
        if (res.data.status === 200) {
          this.$Message.success('下载成功');
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    declarationReconciliation() {
      const params = Object.assign({}, this.query);

      if (params.duration && params.duration.length) {
        params.startDate = params.duration[0];
        params.endDate = params.duration[1];
      }
      insurance.declarationReconciliation(params).then((res) => {
        if (res.data.status === 200) {
          this.$Message.success('下载成功');
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    statement() {
      const params = Object.assign({}, this.query);
      insurance.statement(params).then((res) => {
        if (res.data.status === 200) {
          this.$Message.success('下载成功');
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    statementMonthCount() {
      const params = Object.assign({}, this.query);
      insurance.statementMonthCount(params).then((res) => {
        if (res.data.status === 200) {
          this.$Message.success('下载成功');
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    // 费用明细和结算信息下载
    costInfoDownload(flag) { // true:费用明细 false:结算信息
      const params = Object.assign({}, this.query);
      // 入院起止日期
      if (params.hospitalizedRange && params.hospitalizedRange.length === 2) {
        params.hospitalizedStartTime = params.hospitalizedRange[0];
        params.hospitalizedEndTime = params.hospitalizedRange[1];
        delete params.hospitalizedRange;
      }
      // 结算起止日期
      if (params.settlementRange && params.settlementRange.length === 2) {
        params.settlementStartTime = params.settlementRange[0];
        params.settlementEndTime = params.settlementRange[1];
        delete params.settlementRange;
      }
      // 医保那边需要传递的字段
      params.medicineSerialNo = '';
      params.AKA130 = '';
      params.BKC036 = '';
      params.BKC083 = '';
      params.AKA120 = '';
      params.ACK222 = '';
      params.BKC023 = '';
      params.BKC051 = '';
      const finalAction = flag ? insurance.expenseDetailExport : insurance.settlementExport;
      finalAction(params).then((res) => {
        utils.downLoadExcel(res);
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    monthSettlementExport() {
      const params = Object.assign({}, this.query);
      insurance.monthSettlementExport(params).then((res) => {
        utils.downLoadExcel(res);
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    userCheckInsurance() {
      // const params = Object.assign({}, this.query);
      insurance.insuranceUser({
        lsCslx: 1,
        asBaa001: 61990001,
      }).then((res) => {
        const { status, data, error } = res.data;
        if (status === 200) {
          this.userInfo = data;
          const { aac001 } = this.userInfo;
          insurance.specialDisease({ aac001 }).then((sub) => {
            if (sub.data.status === 200) {
              this.$set(this.userInfo, 'diseaseStr', sub.data.data.map(item => item.aka121).join(','));
              // this.userInfo.diseaseStr = sub.data.data.map(item => item.aka121).join(',');
            } else {
              this.$Message.error(error);
            }
          }).catch((err) => {
            utils.handleError(err);
          });
        } else {
          this.$Message.error(error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getUserList() {
      insurance.getUserList().then((res) => {
        if (res.data.status === 200) {
          this.userList = res.data.data;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  created() {
    this.getUserList();
  },
};

</script>
<style lang="less" scoped>
  .queryList {
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    .queryItem {
      flex-shrink: 0;
      display: flex;
      align-items: center;
      margin-bottom: 8px;
      margin-right: 8px;

      *:last-child {
        width: 256px
      }

      label {

        margin-right: 8px
      }
    }
  }

</style>
